import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Col, Row, Tooltip, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { styleVariables, getSize, MathEnabledTextComponent, getColor } from '@lib/common';
import { ScoreInput, getAnswerStatusColorTooltip } from '@module/assignment-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var StyledAnswerItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding8'));
var StyledAnswerItemLayout = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ", ";\n  width: 100%;\n  padding: ", " ", ";\n  margin-bottom: ", ";\n\n  border: 1px solid #cbd5e1;\n\n  background-color: #faf8fc;\n\n  border-radius: ", ";\n"])), getSize('padding8'), getSize('padding8'), getSize('padding12'), getSize('padding16'), getSize('radiusSm'));
var StyledIndexPrefix = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: #334155;\n  flex-shrink: 0;\n\n  min-width: 28px;\n\n  text-align: center;\n"])), getSize('typo14'));
var StyledSelectWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 200px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  .ant-select {\n    width: 100%;\n  }\n\n  .ant-select-selector {\n    min-height: 36px;\n    height: auto !important;\n    padding: ", " ", " !important;\n    border: 1px solid #cbd5e1 !important;\n    border-radius: ", " !important;\n    background-color: ", " !important;\n    box-shadow: none !important;\n\n    &:hover {\n      border-color: #cbd5e1 !important;\n    }\n  }\n\n  .ant-select-focused .ant-select-selector {\n    border-color: #cbd5e1 !important;\n    box-shadow: 0 0 0 2px\n      ", " !important;\n  }\n\n  .ant-select-selection-placeholder {\n    color: #94a3b8;\n    font-size: ", ";\n    line-height: 1.5;\n  }\n\n  .ant-select-selection-item {\n    white-space: normal;\n    word-wrap: break-word;\n    line-height: 1.5;\n    padding: 0;\n    color: #334155;\n    font-size: ", ";\n  }\n\n  .ant-select-arrow {\n    color: #64748b;\n  }\n\n  // Style cho dropdown options\n  .ant-select-dropdown {\n    border-radius: ", ";\n    box-shadow:\n      0 4px 6px -1px rgba(0, 0, 0, 0.1),\n      0 2px 4px -1px rgba(0, 0, 0, 0.06);\n\n    .ant-select-item {\n      white-space: normal;\n      word-wrap: break-word;\n      padding: ", " ", ";\n      line-height: 1.5;\n      color: #334155;\n      font-size: ", ";\n    }\n\n    .ant-select-item-option-selected {\n      background-color: #faf8fc;\n      color: ", ";\n      font-weight: 500;\n    }\n\n    .ant-select-item-option-active {\n      background-color: #f8fafc;\n    }\n\n    .ant-select-item-option-content {\n      white-space: normal;\n      word-wrap: break-word;\n    }\n  }\n"])), getSize('padding8'), getSize('padding8'), getSize('padding12'), getSize('radiusSm'), function (_ref) {
  var $status = _ref.$status;
  if ($status === 'correct') return getColor('successBgActive');
  if ($status === 'manuallyAwarded') return '#FFF7E6';
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorBgActive');
  return '#ffffff';
}, function (_ref2) {
  var $status = _ref2.$status;
  if ($status === 'correct') return getColor('successBgActive');
  if ($status === 'manuallyAwarded') return '#FFF7E6';
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorBgActive');
  return 'rgba(124, 58, 237, 0.1)';
}, getSize('typo14'), getSize('typo14'), getSize('radiusSm'), getSize('padding8'), getSize('padding12'), getSize('typo14'), getColor('fillIntActive'));
var StyledStatusIcon = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  flex-shrink: 0;\n"])), getSize('typo16'), function (_ref3) {
  var $status = _ref3.$status;
  if ($status === 'correct') return getColor('successActive');
  if ($status === 'manuallyAwarded') return styleVariables.colors.gold1;
  if ($status === 'incorrect') return getColor('errorActive');
  return '#94a3b8';
});
var StyledSubQuestionDescription = styled(MathEnabledTextComponent)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n  color: #334155;\n  line-height: ", ";\n  flex: 1;\n\n  p {\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"])), getSize('typo14'), getSize('padding20'));
var StyledCorrectAnswerText = styled.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  min-width: 80px;\n  flex-shrink: 0;\n  text-align: left;\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), getSize('typo14'), styleVariables.font.fontWeightStrong, function (props) {
  return props.$error ? props.theme.color.fontColorError : props.theme.color.fontColorSuccess;
});
var StyledScoreInputContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 1px;\n  flex-shrink: 0;\n"])));
var StyledCorrectAnswerRow = styled(Row)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), getSize('padding16'));
var AnswerStatus;

(function (AnswerStatus) {
  AnswerStatus["Correct"] = "correct";
  AnswerStatus["Incorrect"] = "incorrect";
  AnswerStatus["Skipped"] = "skipped";
  AnswerStatus["ManuallyAwarded"] = "manuallyAwarded";
})(AnswerStatus || (AnswerStatus = {}));

var getScoreInputValue = function getScoreInputValue(score) {
  return score !== SubmissionScore["default"].value ? score : null;
};

var getSavedAnswerId = function getSavedAnswerId(matchingGroupAnswer, subQuestionId) {
  var _matchingGroupAnswer$, _matchingGroupAnswer$2, _matchingGroupAnswer$3;

  return matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : (_matchingGroupAnswer$ = matchingGroupAnswer.answers) === null || _matchingGroupAnswer$ === void 0 ? void 0 : (_matchingGroupAnswer$2 = _matchingGroupAnswer$.find(function (a) {
    return a.subQuestionId === subQuestionId;
  })) === null || _matchingGroupAnswer$2 === void 0 ? void 0 : (_matchingGroupAnswer$3 = _matchingGroupAnswer$2.value) === null || _matchingGroupAnswer$3 === void 0 ? void 0 : _matchingGroupAnswer$3.answerId;
};

export var MatchingGradingAnswers = function MatchingGradingAnswers(_ref4) {
  var matchingQuestion = _ref4.matchingQuestion,
      matchingGroupAnswer = _ref4.matchingGroupAnswer,
      label = _ref4.label,
      isSubmissionSubmitted = _ref4.isSubmissionSubmitted,
      submitGradeAnswer = _ref4.submitGradeAnswer,
      disabled = _ref4.disabled,
      updatedAnswerId = _ref4.updatedAnswerId,
      isPreviewMode = _ref4.isPreviewMode,
      answerOptions = _ref4.answerOptions,
      isShowingExplanation = _ref4.isShowingExplanation,
      _ref4$isShowingScoreI = _ref4.isShowingScoreInput,
      isShowingScoreInput = _ref4$isShowingScoreI === void 0 ? true : _ref4$isShowingScoreI;

  var renderScoreInput = function renderScoreInput(answeredSubQuestion, correctAnswer, submitAnswerScore) {
    if (!isShowingScoreInput) return null;
    var scoreValue = getScoreInputValue(answeredSubQuestion.score);
    var isGraded = answeredSubQuestion.hasGraded();
    var isDisabled = disabled || updatedAnswerId === answeredSubQuestion.id.toString();

    var scoreInput = /*#__PURE__*/_jsx(StyledScoreInputContainer, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: correctAnswer.score,
        label: label,
        submitScore: submitAnswerScore,
        value: scoreValue,
        disabled: isPreviewMode || isDisabled,
        active: isGraded,
        danger: isGraded && answeredSubQuestion.score === 0
      })
    });

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.disabledScoreInputText,
        children: scoreInput
      });
    }

    return scoreInput;
  };

  var renderAnswerStatus = function renderAnswerStatus(answeredSubQuestion, correctAnswer) {
    var _answeredSubQuestion$;

    if (!answeredSubQuestion.value) {
      if (!isSubmissionSubmitted) {
        return null;
      }

      return AnswerStatus.Skipped;
    }

    var correctAnswerId = correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answerId;
    var selectedAnswerId = (_answeredSubQuestion$ = answeredSubQuestion.value) === null || _answeredSubQuestion$ === void 0 ? void 0 : _answeredSubQuestion$.answerId;

    if (correctAnswerId === selectedAnswerId) {
      return AnswerStatus.Correct;
    }

    if (answeredSubQuestion.hasGraded() && typeof answeredSubQuestion.score === 'number' && answeredSubQuestion.score > 0) {
      return AnswerStatus.ManuallyAwarded;
    }

    return AnswerStatus.Incorrect;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: (matchingQuestion.subQuestions || []).map(function (subQ, index) {
      var _find;

      var answeredSubQuestion = matchingGroupAnswer === null || matchingGroupAnswer === void 0 ? void 0 : matchingGroupAnswer.answers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });
      var correctAnswer = (matchingQuestion.correctAnswers || []).find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });

      if (!answeredSubQuestion) {
        return null;
      }

      var correctAnswerDescription = (_find = (matchingQuestion.answers || []).find(function (a) {
        return a.id.toString() === (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answerId);
      })) === null || _find === void 0 ? void 0 : _find.description;

      var submitAnswerScore = function submitAnswerScore(score) {
        if (submitGradeAnswer) {
          submitGradeAnswer(score, answeredSubQuestion.id.toString());
        }
      };

      var savedAnswerId = getSavedAnswerId(matchingGroupAnswer, subQ.id.toString()) || '-';
      var answerStatus = renderAnswerStatus(answeredSubQuestion, correctAnswer);
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(StyledAnswerItemLayout, {
          children: [/*#__PURE__*/_jsxs(StyledAnswerItem, {
            children: [/*#__PURE__*/_jsxs(StyledIndexPrefix, {
              children: [index + matchingQuestion.index, "."]
            }), /*#__PURE__*/_jsx(Tooltip, {
              title: getAnswerStatusColorTooltip(answerStatus, {
                correct: label.colorStatusCorrect,
                incorrect: label.colorStatusIncorrect,
                customGrade: label.colorStatusCustomGrade,
                skipped: label.colorStatusSkipped
              }),
              children: /*#__PURE__*/_jsxs(StyledSelectWrapper, {
                $status: answerStatus,
                children: [/*#__PURE__*/_jsx(Select, {
                  value: savedAnswerId,
                  disabled: true,
                  placeholder: "Select answer...",
                  style: {
                    width: '100%'
                  },
                  dropdownStyle: {
                    maxWidth: '400px'
                  },
                  optionLabelProp: "label",
                  children: answerOptions.map(function (option) {
                    return /*#__PURE__*/_jsx(Option, {
                      value: option.value,
                      label: option.label,
                      children: /*#__PURE__*/_jsx("div", {
                        style: {
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          lineHeight: '1.5'
                        },
                        children: option.label
                      })
                    }, option.value);
                  })
                }), answerStatus && /*#__PURE__*/_jsxs(StyledStatusIcon, {
                  $status: answerStatus,
                  children: [(answerStatus === AnswerStatus.Correct || answerStatus === AnswerStatus.ManuallyAwarded) && /*#__PURE__*/_jsx(CheckCircleOutlined, {}), answerStatus === AnswerStatus.Incorrect && /*#__PURE__*/_jsx(CloseCircleOutlined, {})]
                })]
              })
            }), subQ.description && /*#__PURE__*/_jsx(StyledSubQuestionDescription, {
              value: subQ.description
            }), (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.score) && renderScoreInput(answeredSubQuestion, correctAnswer, submitAnswerScore)]
          }), /*#__PURE__*/_jsx("div", {
            style: {
              width: '100%'
            },
            children: (answerStatus === AnswerStatus.Incorrect || answerStatus === AnswerStatus.Skipped) && correctAnswerDescription && isShowingExplanation && /*#__PURE__*/_jsx(StyledCorrectAnswerRow, {
              children: /*#__PURE__*/_jsx(Col, {
                span: 12,
                children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
                  children: ["(", label.correctAnswer, ": ", correctAnswerDescription, ")"]
                })
              })
            })
          })]
        })
      }, subQ.id.toString());
    })
  });
};